export const characterComments = [
  {
    id: "c1",
    user: "追剧的鱼",
    time: "2 小时前",
    content: "这个角色的动机其实一直藏在细节里，第二遍看才完全懂他的选择。",
    likes: 128
  },
  {
    id: "c2",
    user: "光影观察员",
    time: "昨天",
    content: "作者分析得很到位，尤其是关于“放下”的那一段，完全说中了我的感受。",
    likes: 96
  },
  {
    id: "c3",
    user: "南风知我意",
    time: "3 天前",
    content: "一开始只觉得他执拗，看完分析才发现那份执拗是对自己的一种交代。",
    likes: 74
  },
  {
    id: "c4",
    user: "深夜放映厅",
    time: "5 天前",
    content: "希望后续能出一篇关于这个角色与其他人物关系的梳理，太值得细看了。",
    likes: 52
  }
];